import { Directive, Input, Output, ElementRef, HostListener, EventEmitter } from '@angular/core';


/**------------------------------------------------------
 * Select Element
 * --------------
 * The use case is to select elements on mouse drag
 *
 * Example:
 * --------
 * 	<div ngDragSelect [(isSelected)]="isSelected"> ... </div>
 */
@Directive({
    selector: '[ngDragSelect]',
    standalone: false
})
export class NgDragSelectDirective {

	@Input()  isSelected				: boolean = false;
	@Output() readonly isSelectedChange	: EventEmitter<boolean> = new EventEmitter<boolean>();

	//** Helper Variables */
	isCtrlPressed	: boolean = false;
	isAltPressed	: boolean = false;
	isSelectable	: boolean = true;

	constructor(
		private hostElement: ElementRef
	) {
		// prevent the image dragging
		this.hostElement.nativeElement.setAttribute('draggable', false);
		this.hostElement.nativeElement.style['-webkit-user-drag'] = 'none';
	}

	@HostListener('mousedown', ['$event'])
	public onMouseDown(event: MouseEvent): void {

		// change the selected state
		if (event.buttons === 1) {
			this.isSelected = !this.isSelected;
			this.isSelectedChange.emit(this.isSelected);
			this.isSelectable = false;
		}
	}

	@HostListener('mouseover', ['$event'])
	public onMouseover(event: MouseEvent): void {

		// change the selected state
		if (event.buttons === 1 && this.isSelectable) {
			if (event.ctrlKey) this.isSelected = true;
			else if (event.altKey) this.isSelected = false;
			else this.isSelected = !this.isSelected;
			this.isSelectedChange.emit(this.isSelected);
			this.isSelectable = false;
		}
	}

	@HostListener('mouseout', ['$event'])
	public onMouseout(event: MouseEvent): void {
		const bounds  : DOMRect = this.hostElement.nativeElement.getBoundingClientRect();
		const outsideX: boolean = event.clientX <= bounds.left 	|| event.clientX >= bounds.right;
		const outsideY: boolean = event.clientY <= bounds.top 	|| event.clientY >= bounds.bottom;
		if (outsideX || outsideY) this.isSelectable = true;
	}
}
